
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


const imgList = [
'/static/3DSMAX.jpg',
'/static/illustrator.jpg',
'/static/PS.jpg',
'/static/AllStudyPC.jpg'
]

const demoList = imgList.map((one, index) => ({
url: 'javascript:',
img: one
}))

export default {
directives: {
TransferDom
},
components: {
Swiper,
Flexbox,
FlexboxItem,
ViewBox,
Loading,
Popover,
Tab,
TabItem,
XDialog
},
data() {
return {
demo_list: demoList,
hotList: [],
newList: [],
allList: [],
touchStart: "",
touchEnd: "",
resourceURL: ""
}

},
methods: {
jumpDisease: function(index) {


var CourseID = ["Course51587","Course51588","Course51589","Course51590","Course51591","Course51592"];
this.JumpVideo('/Index/Course',CourseID[index-1])
},
gotoQBZ: function() {
window.open("https://www.jqweike.cn");
},
cutName: function(str) {
if (str.length > 10) {
return str.substring(0, 9) + "..";
} else {
return str;
}
},
jump: function(e, type) {
this.$router.push({
path: e,
name: "CourseMore",
params: {
type: type
}
})
},
JumpVideo: function(url, IDCode) {

this.$router.push({
path: url,
name: url,
params: {
IDCode: IDCode,
level1: "首页",
level2: "",
level3: "",
}
})
},

GetHotlist: function() {
this.$tyh.GetHotlist()
.then((data) => {
if (data.data.Status != 0) {
return;
}
var show_data = new Array();
for (var t in data.data.Data.rows) {
var time = this.$tyh.formatSeconds(data.data.Data.rows[t].PlayTime);
var name = data.data.Data.rows[t].Name;
if (name.length > 40) {
name = name.substr(0, 40) + "...";
}
var showdatas = {
IDCode: data.data.Data.rows[t].IDCode,
ResCount: data.data.Data.rows[t].ResCount,
Logo: data.data.Data.rows[t].Logo,
Content: data.data.Data.rows[t].Content,
ViewCount: data.data.Data.rows[t].ViewCount,
Name: name,
PlayTime: time
}
show_data.push(showdatas)
}
this.hotList = show_data
})
.catch(function(data) {
console.log(data);
});
},
GetNewList: function() {
this.$tyh.GetNewlist()
.then((data) => {
if (data.data.Status != 0) {
return;
}
var show_data = new Array();
for (var t in data.data.Data.rows) {
var time = this.$tyh.formatSeconds(data.data.Data.rows[t].PlayTime);
var name = data.data.Data.rows[t].Name;
if (name.length > 40) {
name = name.substr(0, 40) + ".";
}
var showdatas = {
IDCode: data.data.Data.rows[t].IDCode,
ResCount: data.data.Data.rows[t].ResCount,
Logo: data.data.Data.rows[t].Logo,
Content: data.data.Data.rows[t].Content,
ViewCount: data.data.Data.rows[t].ViewCount,
Name: name,
PlayTime: time
}
show_data.push(showdatas)
}
this.newList = show_data
setTimeout(() => {
this.$vux.loading.hide()
}, 0);
})
.catch(function(data) {
console.log(data);
});
}
},
mounted() {
this.$vux.loading.show({
text: 'Loading'
});

this.resourceURL = this.$tyh.RESOURCEURL;
const _this = this;

setTimeout(() => {

_this.GetHotlist();
_this.GetNewList();
}, 1000)
},
watch: {
allList(val, oldVal) {
this.$nextTick(function() {
if (val.length == "9") {
this.$vux.loading.hide()
}
})
},
hotList(val, oldVal) {
this.$nextTick(function() {
if (val) {
this.allList = this.allList.concat(this.hotList);
}
})
},
newList(val, oldVal) {
this.$nextTick(function() {
if (val) {
this.allList = this.allList.concat(this.newList);
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/components/IndexCourse.vue